import type { Route } from '~/core/router'

import { appearanceFeature } from '~/features/appearance'
import { SEARCH } from '~/shared/routes'

export const before: Route[] = [
  {
    // redirects to the first module from appearance response, if any
    path: '/',
    fn: {
      source: appearanceFeature.$modules,
      fn: (modules) => {
        if (modules?.length > 0) {
          return { redirect: `/modules/${modules[0].identifier}` }
        }
        return { redirect: '/modules/home' }
      },
    },
  },
  {
    path: '/catchups',
    action: () => ({
      redirect: `/modules/catchups${location.search}`,
    }),
  },
  {
    path: '/catchups/:catchupId',
    action: (__, { catchupId }) => ({
      redirect: `/modules/catchups/${catchupId}${location.search}`,
    }),
  },
  {
    path: '/catchups/:catchupId/channel/:channelId',
    action: (__, { catchupId, channelId }) => ({
      redirect: `/modules/catchups/${catchupId}/channel/${channelId}${location.search}`,
    }),
  },
  {
    path: '/catchups/:catchupId/channel/:channelId/date/:timestamp',
    action: (__, { catchupId, channelId, timestamp }) => ({
      redirect: `/modules/catchups/${catchupId}/channel/${channelId}/date/${timestamp}${location.search}`,
    }),
  },
  {
    path: '/epg',
    action: () => ({
      redirect: `/modules/epg${location.search}`,
    }),
  },
  {
    path: '/events',
    action: () => ({
      redirect: `/modules/events${location.search}`,
    }),
  },
  {
    path: '/events/:eventId',
    action: (__, { eventId }) => ({
      redirect: `/content/event/${eventId}${location.search}`,
    }),
  },
  {
    path: '/library',
    action: () => ({
      redirect: `/modules/library${location.search}`,
    }),
  },
  {
    path: '/library/favorites/movies',
    action: () => ({
      redirect: `/modules/library/favorites/movies${location.search}`,
    }),
  },
  {
    path: '/library/favorites/shows',
    action: () => ({
      redirect: `/modules/library/favorites/shows${location.search}`,
    }),
  },
  {
    path: '/library/favorites/tv',
    action: () => ({
      redirect: `/modules/library/favorites/tv${location.search}`,
    }),
  },
  {
    path: '/library/purchased/events',
    action: () => ({
      redirect: `/modules/library/purchased/events${location.search}`,
    }),
  },
  {
    path: '/library/purchased/movies',
    action: () => ({
      redirect: `/modules/library/purchased/movies${location.search}`,
    }),
  },
  {
    path: '/library/purchased/shows',
    action: () => ({
      redirect: `/modules/library/purchased/shows${location.search}`,
    }),
  },
  {
    path: '/library/purchased/tv',
    action: () => ({
      redirect: `/modules/library/purchased/tv${location.search}`,
    }),
  },
  {
    path: '/movies',
    action: () => ({
      redirect: `/modules/movie${location.search}`,
    }),
  },
  {
    path: '/movies/:vodId',
    action: (__, { vodId }) => ({
      redirect: `/content/movie/${vodId}${location.search}`,
    }),
  },
  {
    path: '/movies/bundles/:bundleId',
    action: (__, { bundleId }) => ({
      redirect: `/content/movie/bundles/${bundleId}${location.search}`,
    }),
  },
  {
    path: '/movies/categories/:categoryId',
    action: (__, { categoryId }) => ({
      redirect: `/content/movie/categories/${categoryId}${location.search}`,
    }),
  },
  {
    path: '/movies/categories/:categoryId/subcategories',
    action: (__, { categoryId }) => ({
      redirect: `/content/movie/categories/${categoryId}/subcategories${location.search}`,
    }),
  },
  {
    path: '/movies/categories/:categoryId/subcategories/:subCategoryId',
    action: (__, { categoryId, subCategoryId }) => ({
      redirect: `/content/movie/categories/${categoryId}/subcategories/${subCategoryId}${location.search}`,
    }),
  },
  {
    path: '/partner-program',
    action: () => ({
      redirect: `/modules/partner${location.search}`,
    }),
  },
  {
    path: '/partner-program/:partnerProductId',
    action: (__, { partnerProductId }) => ({
      redirect: `/content/partner/${partnerProductId}${location.search}`,
    }),
  },
  {
    path: '/search',
    action: () => ({
      redirect: `${SEARCH.ROOT}${location.search}`,
    }),
  },
  {
    path: '/search/:contentType',
    action: (__, { contentType }) => ({
      redirect: `${SEARCH.results(contentType as string)}${location.search}`,
    }),
  },
  {
    path: '/settings',
    action: () => ({
      redirect: `/modules/settings${location.search}`,
    }),
  },
  {
    path: '/settings/content-settings',
    action: () => ({
      redirect: `/modules/settings/content-settings${location.search}`,
    }),
  },
  {
    path: '/settings/info',
    action: () => ({
      redirect: `/modules/settings/info${location.search}`,
    }),
  },
  {
    path: '/shows',
    action: () => ({
      redirect: `/modules/tv_shows${location.search}`,
    }),
  },
  {
    path: '/shows/:showId',
    action: (__, { showId }) => ({
      redirect: `/content/series/${showId}${location.search}`,
    }),
  },
  {
    path: '/shows/:showId/seasons',
    action: (__, { showId }) => ({
      redirect: `/content/series/${showId}/seasons${location.search}`,
    }),
  },
  {
    path: '/shows/:showId/seasons/:seasonId',
    action: (__, { showId, seasonId }) => ({
      redirect: `/content/series/${showId}/seasons/${seasonId}${location.search}`,
    }),
  },
  {
    path: '/shows/bundles/:bundleId',
    action: (__, { bundleId }) => ({
      redirect: `/content/series/bundles/${bundleId}${location.search}`,
    }),
  },
  {
    path: '/shows/categories/:categoryId',
    action: (__, { categoryId }) => ({
      redirect: `/content/series/categories/${categoryId}${location.search}`,
    }),
  },
  {
    path: '/shows/categories/:categoryId/subcategories',
    action: (__, { categoryId }) => ({
      redirect: `/content/series/categories/${categoryId}/subcategories${location.search}`,
    }),
  },
  {
    path: '/shows/categories/:categoryId/subcategories/:subCategoryId',
    action: (__, { categoryId, subCategoryId }) => ({
      redirect: `/content/series/categories/${categoryId}/subcategories/${subCategoryId}${location.search}`,
    }),
  },
  {
    path: '/tv',
    action: () => ({
      redirect: `/modules/tv_channels${location.search}`,
    }),
  },
  {
    path: '/tv/bundles/:bundleId',
    action: (__, { bundleId }) => ({
      redirect: `/content/live/bundles/${bundleId}${location.search}`,
    }),
  },
  {
    path: '/tv/categories/:categoryId',
    action: (__, { categoryId }) => ({
      redirect: `/content/live/categories/${categoryId}${location.search}`,
    }),
  },
  {
    path: '/player/show',
    action: () => ({ redirect: `/player/series${location.search}` }),
  },
  {
    path: '/player/tv',
    action: () => ({ redirect: `/player/live${location.search}` }),
  },
  {
    path: '/player/vod',
    action: () => ({ redirect: `/player/movie${location.search}` }),
  },
]
